import {Injectable} from '@angular/core';
import {Apollo} from 'apollo-angular';
import {PlantillaModel} from '../models/plantilla.model';
import {EDITPLANTILLA, GETALLPLANTILLAS, GETPLANTILLA, NEWPLANTILLA} from '../queries/plantilla.query';
import {SocketServices} from '../../CoreModule/services/socket.services';
import {Observable} from 'rxjs';

@Injectable()
export class PlantillasServices {

  public obsGetPlantilla: Observable<any>;

    constructor(private apollo:Apollo, private ss:SocketServices){
      this.obsGetPlantilla = this.ss.registrarEvento("sendPlantilla");
    }

    getAllPlantillas(){
      return this.apollo.query({
        query:GETALLPLANTILLAS
      })

    }

    getPlantilla(id:any){
      this.ss.enviarEvento("getPlantilla",{id:id});
      // return this.apollo.query({
      //   query:GETPLANTILLA,
      //   variables:{
      //     id:id
      //   }
      // })
    }

    togglePlantillaActiva(id:any){
      this.ss.enviarEvento("togglePlantilla",{id:id});
    }

    newPlantilla(plantilla:PlantillaModel){
      let data = JSON.stringify(plantilla);

      return this.apollo.mutate({
        mutation: NEWPLANTILLA,
        variables:{
          plantilla:data
        }
      })
    }

    editPlantilla(plantilla:PlantillaModel){
      let data = JSON.stringify(plantilla);

      return this.apollo.mutate({
        mutation:EDITPLANTILLA,
        variables:{
          id:plantilla._id,
          plantilla:data
        }
      })
    }

}
